module.exports = __webpack_public_path__ + "stratumblue_web_banner.jpg?0b3ea068aca1a9a32ef5d7d3b1ce6bb1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/stratumblue_web_banner.jpg
// module id = 760
// module chunks = 2